import React, {useState} from 'react';
import {Icon, Modal, Grid, Button} from 'semantic-ui-react';

const WtsMonthlyActivitiesTechDetailsModal = () => {
  const [showModal, setShowModal] = useState(false);

  const showModalClick = (e, value) => {
    e.preventDefault();
    setShowModal(value);
  };

  return (
    <Modal open={showModal}
      trigger={
        <Icon name='info circle' size="big" color="blue" link
          onClick={(e) => showModalClick(e, true)} />
      }>
      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>
            Detalles técnicos: Actividades Mensuales
          </h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => showModalClick(e, false)} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <Grid celled>
          <Grid.Row>
            <Grid.Column width={2}>Frontend</Grid.Column>
            <Grid.Column width={14}>
              /src/wts/components/registroTrabajoAgencias
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}>Backend</Grid.Column>
            <Grid.Column width={14}>
              <div><strong>getTrabajoAgencias</strong>: GET /wts/trabajoAgencias?idarea=[idarea]</div>
              <div>
                <strong>createTrabajoAgencia</strong>: POST /wts/trabajoAgencias
              </div>
              <div>
                <strong>updateTrabajoAgencia</strong>: PUT /wts/trabajoAgencias?id=[id]
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}>BDD</Grid.Column>
            <Grid.Column width={14}>
              <div>wts.tde_tipo_trabajo_agencia_res</div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}>Manual de usuario</Grid.Column>
            <Grid.Column width={14}>
              <div style={{'display': 'flex', 'alignItems': 'center'}}>
                <a
                  href="https://scribehow.com/viewer/WTS__Modulo_de_registro_de_tareas_periodo__8WbA3PSISy66JiXeKA8ycw"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{'marginRight': '20px'}}
                >
                  Registro de tareas (Scribe - Externo)
                </a>
                <Button
                  as="a"
                  href="/media/docs/manualWTS.pdf"
                  download="manualWTS.pdf"
                  size="small"
                  color="blue"
                >
                  <Icon name="file pdf outline" /> Descargar PDF
                </Button>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
    </Modal>
  );
};

export default WtsMonthlyActivitiesTechDetailsModal;
